import { AnyAction } from "redux";
import {
    FETCH_INSTALLMENTS, RECEIVE_INSTALLMENTS, RECEIVE_INSTALLMENT_CONTEXT,
    SAVE_INSTALLMENT, SAVE_INSTALLMENT_SUCCESS,
    DELETE_INSTALLMENT, DELETE_INSTALLMENT_SUCCESS,
    FETCH_INSTALLMENTS_SUMMARY, RECEIVE_INSTALLMENTS_SUMMARY,
    FETCH_INSTALLMENTS_DETAILED, RECEIVE_INSTALLMENTS_DETAILED
} from "../actionTypes";

interface InstallmentState {
    isFetching: boolean;
    isSaving: boolean;
    isFetchingSummary: boolean;
    isFetchingDetailed: boolean;
    installments: any[];
    enrollment: any;
    student: any;
    sumOpen: any;
    sumOpenDetailed: any[];
}

const initialState: InstallmentState = {
    isFetching: false,
    isSaving: false,
    isFetchingSummary: false,
    isFetchingDetailed: false,
    installments: [],
    enrollment: null,
    student: null,
    sumOpen: null,
    sumOpenDetailed: [],
}

const installmentReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case FETCH_INSTALLMENTS: return { ...state, isFetching: true };
        case RECEIVE_INSTALLMENTS: return { ...state, isFetching: false, installments: action.payload };
        case RECEIVE_INSTALLMENT_CONTEXT: return { ...state, enrollment: action.payload.enrollment, student: action.payload.student };
        case SAVE_INSTALLMENT: return { ...state, isSaving: true };
        case SAVE_INSTALLMENT_SUCCESS: return { ...state, isSaving: false };
        case DELETE_INSTALLMENT: return { ...state, isSaving: true };
        case DELETE_INSTALLMENT_SUCCESS: return { ...state, isSaving: false };
        case FETCH_INSTALLMENTS_SUMMARY: return { ...state, isFetchingSummary: true };
        case RECEIVE_INSTALLMENTS_SUMMARY: return { ...state, isFetchingSummary: false, sumOpen: action.payload };
        case FETCH_INSTALLMENTS_DETAILED: return { ...state, isFetchingDetailed: true };
        case RECEIVE_INSTALLMENTS_DETAILED: return { ...state, isFetchingDetailed: false, sumOpenDetailed: action.payload };
        default: return state;
    }
}
export default installmentReducer;
